import { useEffect } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { useIsSmallMode } from '@frontend/shared';
import { Button, Tray, useModalControl } from '@frontend/design-system';
import { useAnalyticsReportingShallowStore } from '../hooks/use-analytics-reporting-store';
import { DownloadTrigger } from './download-trigger';
import { ExportContent } from './export-content';
import { FloatingStatus } from './floating-status';

export const GenerateAnalyticsReportCTA = () => {
  const { t } = useTranslation('analytics-reporting');
  const { closeModal, modalProps, triggerProps } = useModalControl();
  const { isSmallMode } = useIsSmallMode();
  const { selectedLocationIds } = useAppScopeStore();
  const { onInitializeStore } = useAnalyticsReportingShallowStore('onInitializeStore');

  useEffect(() => {
    onInitializeStore(selectedLocationIds);
  }, [onInitializeStore, selectedLocationIds]);

  return (
    <>
      <Button iconName='document-filled' size='large' variant='secondary' {...triggerProps}>
        {!isSmallMode && t('Generate Report')}
      </Button>

      <Tray {...modalProps} css={styles.tray} width='smallXL'>
        <ExportContent closeModal={closeModal} />
      </Tray>
      {!modalProps.show && <FloatingStatus />}
      <DownloadTrigger />
    </>
  );
};

const styles = {
  tray: css`
    gap: 0;
    padding: 0;
    width: 100vw;
  `,
};
